import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SEO } from '../components/seo/SEO';
import { Hero } from '../components/sections/Hero';
import { ProductSuite } from '../components/sections/ProductSuite';
import { StrategicAssessment } from '../components/sections/StrategicAssessment';
import { Services } from '../components/sections/Services';
import { Outcomes } from '../components/sections/Outcomes';
import { Proof } from '../components/sections/Proof';
import { Engagement } from '../components/sections/Engagement';
import { ClientLogos } from '../components/sections/ClientLogos';
import { About } from '../components/sections/About';
import { InsightsTeaser } from '../components/sections/InsightsTeaser';
import { Process } from '../components/sections/Process';
import { Contact } from '../components/sections/Contact';
import { AIHighlights } from '../components/sections/AIHighlights';

export const Home: React.FC = () => {
    const { t } = useLanguage();

    return (
        <>
            <SEO
                title="Strategic Corporate Solutions for DACH Enterprises"
                description="Integrova AI is a strategic corporate solution provider delivering value-driven engineering across software assets, governance, and ERP modernization."
                schema={{
                    '@context': 'https://schema.org',
                    '@type': 'ProfessionalService',
                    name: 'Integrova AI',
                    knowsAbout: ['Enterprise Architecture', 'SAP Modernization', 'Cybersecurity', 'AI Strategy'],
                    address: {
                        '@type': 'PostalAddress',
                        addressLocality: 'Münchengladbach',
                        addressCountry: 'DE'
                    },
                    iso27001Certified: true,
                    url: 'https://integrovaai.de',
                    logo: 'https://integrovaai.de/og-default.png',
                    sameAs: ['https://www.linkedin.com'],
                }}
            />
            {/* 1. Hero */}
            <Hero />

            {/* 2. ClientLogos */}
            <ClientLogos />

            {/* 3. AI Highlights - NEW */}
            <AIHighlights />

            {/* 4. Outcomes */}
            <Outcomes />

            {/* 5. Services */}
            <Services />

            {/* 6. ProductSuite */}
            <ProductSuite />

            {/* 7. StrategicAssessment */}
            <StrategicAssessment />

            {/* 8. Proof */}
            <Proof />

            {/* 9. Process */}
            <Process data={t.homeProcess} />

            {/* 10. Engagement */}
            <Engagement />

            {/* 11. InsightsTeaser */}
            <InsightsTeaser />

            {/* 12. About */}
            <About />

            {/* 13. Contact */}
            <Contact />
        </>
    );
};
